import { render, staticRenderFns } from "./AttendanceRateList.vue?vue&type=template&id=6d071fb8"
import script from "../../controllers/attendance_rate/attendance_rate_list.js?vue&type=script&lang=js&external"
export * from "../../controllers/attendance_rate/attendance_rate_list.js?vue&type=script&lang=js&external"
import style0 from "./AttendanceRateList.vue?vue&type=style&index=0&id=6d071fb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports